document.addEventListener("DOMContentLoaded", function () {
  var sleep = 500;
  var productGridContainer = document.querySelector(".product-grid-container");
  var loadMoreButton = document.getElementById("loadMoreButton");

  function showElements(count) {
    var elementsToShow = document.querySelectorAll(".scroll-infinite.d-none");
    for (var i = 0; i < Math.min(count, elementsToShow.length); i++) {
      elementsToShow[i].classList.remove("d-none");
    }
    
    // Ocultar botón si no hay más elementos
    if (document.querySelectorAll(".scroll-infinite.d-none").length === 0) {
      if (loadMoreButton) {
        loadMoreButton.style.display = "none";
      }
    }
  }

  function handleEvent() {
    setTimeout(() => {
      showElements(show_first);
    }, sleep);
  }

  function countElements() {
    var elementsCount = document.querySelectorAll(
      ".product-grid-container .scroll-infinite"
    ).length;
    var counterEl = document.querySelector("#ProductCountDesktop");

    if (counterEl) {
      counterEl.innerHTML = elementsCount + " productos";
    }
  }

  var observer = new MutationObserver(function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList") {
        handleEvent();
      }
    }
  });

  var observerConfig = { childList: true, subtree: true };
  observer.observe(productGridContainer, observerConfig);

  function initializeScript() {
    observer.disconnect();

    // Evento click del botón "Cargar más"
    if (loadMoreButton) {
      loadMoreButton.addEventListener("click", function () {
        showElements(show_first);
      });
    }

    var eventElements = [
      { selector: 'input[type="checkbox"]', event: "click" },
      { selector: "#SortBy", event: "change" },
      { selector: ".active-facets__button-remove", event: "click" },
    ];

    eventElements.forEach(function (element) {
      var elements = document.querySelectorAll(element.selector);
      elements.forEach(function (item) {
        item.addEventListener(element.event, handleEvent);
      });
    });

    showElements(show_first);

    observer.observe(productGridContainer, observerConfig);

    countElements();
  }

  initializeScript();
});
